import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import 'react-phone-number-input/style.css';
import './style.scss';
import { useAppSelector } from 'careand-redux/store';
import DefaultButton from 'components/Utils/NewDefaultButton';
import PatientUtils from 'services/PatientUtils';
import logo from 'assets/img/logo-blue-horizontal.webp';
import { getTenantIdentity } from 'hooks/useTenantIdentity';

const Welcome = ({ track, onSuccess }) => {
  const patientId = useAppSelector((state) => state.authentication.activeUserId);
  const patient = useAppSelector((state) => state.patients.byId[patientId]);

  const name = patient ? PatientUtils.getPreferredName(patient) : '';

  useEffect(() => {
    track('registrationSuccess');
  }, [track]);

  return (
    <>
      <div className="welcome step">
        <div className="welcome-slide">
          <img src={logo} alt={getTenantIdentity().name} />

          <span className="title">Welcome {name}</span>

          <span className="explanation">
            In the next few screens we will walk you through the basic functions of our application
            and make sure that you are all set up and ready to use our services
          </span>
          <DefaultButton name="Let's Get Started" onClick={onSuccess} />
        </div>
      </div>
    </>
  );
};

Welcome.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  track: PropTypes.func.isRequired,
};

export default Welcome;
